/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CardAdminDto } from '../models/CardAdminDto';
import type { GetCardsClientResponse } from '../models/GetCardsClientResponse';
import type { Language } from '../models/Language';
import type { Pagination1OfCardListedAdminDto } from '../models/Pagination1OfCardListedAdminDto';
import type { PostCardAdminRequest } from '../models/PostCardAdminRequest';
import type { PutCardAdminRequest } from '../models/PutCardAdminRequest';
import type { UpdateCardOrderRequestAdmin } from '../models/UpdateCardOrderRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CardsService {
    /**
     * @returns GetCardsClientResponse OK
     * @throws ApiError
     */
    public static getCardsClientClient({
        channelId,
        cachedCards,
        branchTagId,
        userAddressId,
    }: {
        channelId?: number,
        cachedCards?: Array<string>,
        branchTagId?: number,
        userAddressId?: number,
    }): CancelablePromise<GetCardsClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/cards',
            query: {
                'channelId': channelId,
                'cachedCards': cachedCards,
                'branchTagId': branchTagId,
                'userAddressId': userAddressId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetCardsClientResponse OK
     * @throws ApiError
     */
    public static getPublicCardsClientClient({
        language,
        currentLocationLng,
        currentLocationLat,
        channelId,
    }: {
        language: Language,
        currentLocationLng: number,
        currentLocationLat: number,
        channelId?: number,
    }): CancelablePromise<GetCardsClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/cards/public',
            query: {
                'language': language,
                'currentLocationLng': currentLocationLng,
                'currentLocationLat': currentLocationLat,
                'channelId': channelId,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCardDetails`
     * @returns CardAdminDto OK
     * @throws ApiError
     */
    public static getCardAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<CardAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cards/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCards`
     * @returns CardAdminDto OK
     * @throws ApiError
     */
    public static updateCardAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCardAdminRequest,
    }): CancelablePromise<CardAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/cards/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteCards`
     * @returns void
     * @throws ApiError
     */
    public static deleteCardAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/cards/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCards`
     * @returns Pagination1OfCardListedAdminDto OK
     * @throws ApiError
     */
    public static getCardsAdmin({
        includeExpired,
        regionId,
        isEnabled,
        channelId,
        page,
        limit,
    }: {
        includeExpired?: boolean,
        regionId?: number,
        isEnabled?: boolean,
        channelId?: number,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfCardListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cards',
            query: {
                'includeExpired': includeExpired,
                'regionId': regionId,
                'isEnabled': isEnabled,
                'channelId': channelId,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCards`
     * @returns CardAdminDto OK
     * @throws ApiError
     */
    public static postCardAdmin({
        requestBody,
    }: {
        requestBody?: PostCardAdminRequest,
    }): CancelablePromise<CardAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/cards',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCards`
     * @returns void
     * @throws ApiError
     */
    public static updateCardOrderAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: UpdateCardOrderRequestAdmin,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/cards/order/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
